<div class="p-4 md:p-12">
  <div class="flex flex-row items-center mb-6">
    <ng-icon
      name="heroArrowUpRight"
      size="32px"
      class="mr-4 text-gray-500"
    ></ng-icon>
    <h1 class="mb-0">{{ { key: "redirectToPayment" } | i18n }}</h1>
  </div>

  <p>{{ { key: "pleaseWaitForPaymentRedirect" } | i18n }}</p>

</div>
